<template>
  <label
    :class="computedClasses"
    class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium border m-1 select-none"
  >
    <input
      v-if="canBeSelected"
      v-model="computedSelectedTagIds"
      type="checkbox"
      name="tags"
      :value="tag.id"
      :disabled="disabled"
      class="hidden"
    />
    {{ tag.name }}
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    tag: {
      type: Object,
      required: true,
    },
    inherited: Boolean,
    disabled: Boolean,
  },
  computed: {
    selected() {
      return this.value.indexOf(this.tag.id) >= 0;
    },
    canBeSelected() {
      return this.tag.taggableBy.indexOf('contacts') >= 0;
    },
    computedClasses() {
      if (this.disabled) {
        return ['border-gray-300', 'bg-gray-300', 'text-gray-600'];
      }

      if (this.selected) {
        return ['border-blue-600', 'bg-blue-200', 'text-blue-900'];
      }

      if (this.inherited) {
        return ['border-green-600', 'bg-green-200', 'text-green-900'];
      }

      if (!this.canBeSelected) {
        return ['border-gray-300', 'bg-gray-200', 'text-gray-600'];
      }

      return ['border-gray-600', 'text-gray-900'];
    },
    computedSelectedTagIds: {
      get() {
        return this.value;
      },
      set(updatedSelectedTagIds) {
        this.$emit('input', updatedSelectedTagIds);
      },
    },
  },
};
</script>
